<template>
  <span>
    <h3>Seja bem vindo {{usuario.nome}}!</h3>
  </span>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.usuario.usuario
    })
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/Administrativa.vue